import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { shape, string, array, object } from 'prop-types';
import { useStyle } from '../../classify';
import GalleryItemShimmer from './item.shimmer';
import defaultClasses from './gallery.module.css';

var GalleryShimmer = function GalleryShimmer(props) {
  var items = props.items,
      itemProps = props.itemProps;
  var classes = useStyle(defaultClasses, props.classes);
  return React.createElement("div", {
    className: classes.root,
    "aria-live": "polite",
    "aria-busy": "true"
  }, React.createElement("div", {
    className: classes.items
  }, items.map(function (item, index) {
    return React.createElement(GalleryItemShimmer, _extends({
      key: index
    }, itemProps));
  })));
};

GalleryShimmer.defaultProps = {
  items: [],
  itemProps: {}
};
GalleryShimmer.propTypes = {
  classes: shape({
    root: string,
    items: string
  }),
  items: array,
  itemProps: shape({
    classes: object
  })
};
export default GalleryShimmer;